module.exports = __webpack_public_path__ + "img/option_icon.6840994e.svg";